import { defineStore } from "pinia";
import { _GettersTree, _ActionsTree, StoreDefinition } from "pinia";
import type { Guest, VRooma } from "@/@types/vroom/virtualRooma";
import type { VRAudiobooksStatus, VRCinemaStatus } from "@/@types/vroom/virtualRooma";

interface IVR {
  vroom: VRooma | null;
}
interface RVoomActions {
  setRvooma(vr: VRooma): void;
  setGreetingRead(tooglle: boolean): void;
}

const state = (): IVR => ({
  vroom: null as VRooma | null,
});

const getters: _GettersTree<IVR> = {
  hasVroom: (state): boolean => {
    return state.vroom !== null;
  },
  getVroomGuests: (state): Guest[] => {
    return state.vroom ? state.vroom.guests : [];
  },
  roomaID: (state): string => {
    return state.vroom ? state.vroom._id : "";
  },
  smartHomeID: (state): string => {
    return state.vroom ? String(state.vroom.smart_home_id) : "";
  },
  isHello: (state): boolean | undefined => {
    return state.vroom ? state.vroom.confirm.hello : true;
  },
  getRoomName(state): string {
    return state.vroom?.room_name || "";
  },
  getVroomCinema(state): VRCinemaStatus[] {
    return state.vroom?.cinema || [];
  },
  getVroomAudiobooks(state): VRAudiobooksStatus[] {
    return state.vroom?.audiobooks || [];
  },
};

const actions = {
  setRvooma(this: RVoomActions & IVR, vr: VRooma) {
    this.vroom = vr;
  },
  setGreetingRead(this: RVoomActions & IVR, tooglle: boolean) {
    if (!this.vroom) return;
    if (!this.vroom.confirm) {
      this.vroom.confirm = { hello: tooglle, reviews: false };
      return;
    }
    this.vroom.confirm.hello = tooglle;
  },
  setRvoomaCinema(this: RVoomActions & IVR, payload: VRCinemaStatus) {
    if (!this.vroom) return;
    const i = this.vroom.cinema.findIndex((m) => m.movie_id === payload.movie_id);
    if (i === -1) {
      this.vroom.cinema.push({ ...payload });
      return;
    }

    const item = this.vroom.cinema[i];
    item.current_time = payload.current_time;
    item.duration = payload.duration;
    item.active = payload.active;
    if (payload.active) {
      this.vroom.cinema.forEach((m) => {
        if (m.movie_id !== payload.movie_id) m.active = false;
      });
    }
  },
  setRvoomaAudiobooks(this: RVoomActions & IVR, payload: VRAudiobooksStatus) {
    if (!this.vroom) return;
    const i = this.vroom.audiobooks.findIndex((b) => b.book_id === payload.book_id);
    if (i === -1) {
      this.vroom.audiobooks.push({ ...payload });
      return;
    }

    const item = this.vroom.audiobooks[i];
    item.filename = payload.filename;
    item.current_time = payload.current_time;
    item.active = payload.active;
    if (payload.active) {
      this.vroom.audiobooks.forEach((b) => {
        if (b.book_id !== payload.book_id) b.active = false;
      });
    }
  },
};

export const useVRoom: StoreDefinition<
  "vroom",
  IVR,
  _GettersTree<IVR>,
  _ActionsTree
> = defineStore("vroom", {
  state,
  getters,
  actions,
});
